import { Helmet } from 'react-helmet-async';
import Header from '../shared/Header/Header';
import SectionHeader from './../layouts/showcaseLayouts/Section/SectionHeader/SectionHeader';
import BackButton from './../shared/backButton/BackButton';
import InDevelopment from '../pages/showcasePages/InDevelopment/InDevelopment';
import Footer from '../shared/Footer/Footer';
import useIsLTE650 from '../../hooks/useIsLTE650';
import './faqPage.scss';

const FaqPage: React.FC = () => {
    const isMobile = useIsLTE650(650);

    return (
        <div className="faqPage">
            <Helmet>
                <title>Вопросы и ответы S.Gabai</title>
                <meta
                    name="description"
                    content="Вопросы и ответы S.Gabai. Натуральный шелк Tussah и Mulberry, гипоаллергенный текстиль. Производство S-Gabai, доставка по РФ."
                />
            </Helmet>
            <Header isMobile={isMobile} />
            <div className="loyaltyPage_headerWrapper">
                <BackButton absolute />
                <SectionHeader title={'Вопросы и ответы'} />
            </div>
            <InDevelopment />
            <Footer isMobile={isMobile} />
        </div>
    );
};

export default FaqPage;
